import React from 'react';
import styled from 'styled-components';
import sendAnalyticEvent from 'services/analytic/analytic-service';
import { Icon } from '@tvg/fuse-design';
import IconShare from '@tvg/fuse-icons/lib/IphoneShare';
import TertiaryButton from 'components/TertiaryButtonNoBorder/TertiaryButtonNoBorder';
import appWebhook from '@sd-utility/appwebhook';
import { GetValidMediaUrl } from 'utilities/media/media-util';
import { Site } from 'types/GlobalTypes';

type Props = {
  productName: string;
  platform: string;
  site: Site;
  image: string;
};

const StyledIcon = styled(Icon)``;

const StyledButton = styled(TertiaryButton)`
  margin-left: var(--spacing-space32);

  &:hover ${StyledIcon} {
    background-color: var(--color-brand-mid);
  }
`;

const ButtonText = styled.span`
  padding-left: var(--spacing-space4);
  font-weight: normal;
`;

function ShareButton(props: Props) {
  const { productName, platform, site, image } = props;

  const mediaUrl = GetValidMediaUrl(site);

  const productImage = `${mediaUrl}/${image}.jpg?$200x200_socialshare$`;

  const handleAppWebHook = () => {
    const productUrl = window.location.href;

    appWebhook('share', {
      image: productImage,
      link: productUrl,
      product: {
        name: productName,
        url: productUrl,
      },
    });
  };

  const handleShare = () => {
    sendAnalyticEvent({
      gaAction: 'Click',
      gaLabel: 'Share',
    });
    if (platform === 'web') {
      navigator.share({
        url: window.location.href,
        title: productName,
      });
    } else {
      handleAppWebHook();
    }
  };

  return (
    <StyledButton variant="tertiary" onClick={handleShare} data-testid="share-icon-container">
      <>
        <StyledIcon
          title="share"
          desc="share icon for share button"
          dataTestId="share-icon"
          icon={<IconShare />}
          widht="32px"
          height="32px"
        />
        <ButtonText>Share</ButtonText>
      </>
    </StyledButton>
  );
}

export default ShareButton;
